// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__3_5JZ","containerItemsCenter":"Skeleton_containerItemsCenter__3I9Qa"};